import { render, staticRenderFns } from "./DishConfig.vue?vue&type=template&id=51771ed8&scoped=true"
import script from "./DishConfig.vue?vue&type=script&lang=js"
export * from "./DishConfig.vue?vue&type=script&lang=js"
import style0 from "./DishConfig.vue?vue&type=style&index=0&id=51771ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51771ed8",
  null
  
)

export default component.exports